import React from 'react';
import AutoBannerImg from '../Home/Home/AutoBannerImg/AutoBannerImg';
import Top from '../Home/Top/Top';
import Navigation from './../Shared/Navigation/Navigation';
import ResearchBanner from './ResearchBanner/ResearchBanner';

const Research = () => {
    return (
        <div>
         
            <Navigation></Navigation>
            <ResearchBanner></ResearchBanner>
            
        </div>
    );
};

export default Research;